module.exports = __webpack_public_path__ + "fonts/collegiatessoutside-regular-webfont.svg";